import Vue from 'vue'
import Router from 'vue-router'
//登陆
import Login from '@/components/Login'
//   菜单导航
import Menu from '@/components/Menu'
//  首页
import Homepage from '@/components/Homepage'
//项目签约明细页面
import Analyze from '@/components/Analyze'
// 项目签约明细列表中的单个详情
import AnalyzeClick from '@/components/AnalyzeClick'
//. 我 =》 案例大全
import Case from '@/components/Case'
//  案例大全 =》app类型详情页
import CaseApp from '@/components/CaseApp'
//  案例大全 =》其他类型详情页
import CaseOthers from '@/components/CaseOthers'
//  案例大全 =》SAAS类型详情页
import CaseSaas from '@/components/CaseSaas'
// 我的菜单页
import My from '@/components/My'//我的页面
import Mission from '@/components/Mission'
import News from '@/components/News'

//销售业绩
import Sales from '@/components/Sales'

//回款和销售列表
import BackDetail from '@/components/BackDetail'
import BackRank from '@/components/BackRank'

import Performance from '@/components/performance/index'
// 新的销售排名
import Ranking from '@/components/ranking/index'

//分析
import Business from '@/components/Business'

//分析 业务
import BusinessYear from '@/components/BusinessYear'
import BusinessMon from '@/components/BusinessMon'

//分析 制作
import Make from '@/components/Make'

//分析 阿米巴
import Project from '@/components/Project'
//. 分析 =》 阿米巴页 =》 单体数据详情页
import ProjectClick from '@/components/ProjectClick'

import MyProject from '@/components/MyProject'

// 知识库
import Knowledge from '@/components/Knowledge'

// 两汇融合
import Fusion from '@/components/Fusion'
// Bug列表
import BugList from '@/components/BugList'
//我的审核
import Examine from '@/components/Examine'
//分享排行
import ShareRank from '@/components/shareRank'
//分享排行钻取
import ShareDetail from '@/components/drillPage/Share/ShareDetail.vue'
//关联项目
import RelatedProject from '@/components/drillPage/relatedProject/Index.vue'
import relatedProList from '@/components/drillPage/relatedProject/ProList.vue'



//已签约金额／已回款金额钻取
import SignOrBackDrill from '@/components/drillPage/SignOrBackDrill'
//小组回款/销售排行钻取页
import itemBackOrSale from '@/components/drillPage/itemBackOrSale'
//已开票钻取页面
// import SignOrInvoicedDrill from '@/components/drillPage/SignOrInvoicedDrill'
import DeliveryAmountDrill from '@/components/drillPage/DeliveryAmountDrill'
//分析页面右侧按钮点击出现侧滑页面，筛选》时间》区域》确定
import InvoicedReturnDrill from '@/components/drillPage/InvoicedReturnDrill'

import NoInvoicedReturnDrill from '@/components/drillPage/NoInvoicedReturnDrill'
import AreaReturnedMoneyRatioDrill from '@/components/drillPage/AreaReturnedMoneyRatioDrill'

//业务钻取
import DeliveredReturnedMoneyDrill from '@/components/drillPage/DeliveredReturnedMoneyDrill'

//制作钻取
import MakeBackMoneyDrill from '@/components/drillPage/MakeBackMoneyDrill'
import MakeDeliverDrill from '@/components/drillPage/MakeDeliverDrill'
import MakeHasInvoiceReturnMoneyDrill from '@/components/drillPage/MakeHasInvoiceReturnMoneyDrill'
import MakeSomeDrill from '@/components/drillPage/MakeSomeDrill'


//项目预警详情页面
import EarlyWarningProject from '@/components/drillPage/EarlyWarningProject'

//首页6个主要数据的钻取项目项请
import ProjectDetailDrill from '@/components/drillPage/ProjectDetailDrill'
//开票申请页面
import OpenTicket from '@/components/drillPage/OpenTicket'
//开票申请列表页面
import OpenTicketList from '@/components/drillPage/OpenTicketList'
// 开票申请信息项目选择页面
import ProjectList from '@/components/drillPage/ProjectList'

//开票模块页面重构
import TicketApply from '@/components/Ticket/Index'//开票申请界面
import TicketList from '@/components/Ticket/TicketList'//开票列表
import AllProject from '@/components/Ticket/AllProject'//项目名称
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'menu',
      component: Menu,
      children:[
        {
          path: '/',
          name: 'homepage',//首页
          tab:1,
          component: Homepage,
          children:[

          ]
        },
        {
          path: '/sharerank',
          name: 'sharerank',
          component: ShareRank,//分享排行
        },
        {
          path: '/sharedetail',
          name: 'sharedetail',
          component: ShareDetail,//分享排行钻取功能
        },
        　{
          path:'/relatedproject',
          name:'relatedproject',
          component:RelatedProject,//销售关联项目
        },
        {
          path:'/relatedprolist',
          name:'relatedprolist',
          component:relatedProList,
        },

        {
          path: '/bsdrill',
          name: 'bsdrill',
          component: SignOrBackDrill,//已签约金额／已回款金额钻取
        },
        {
          path:'/itemdrill',
          name:'itemdrill',
          component:itemBackOrSale,//小组回款排行
        },

        {
          path: '/dmdrill',
          name: 'dmdrill',
          component: DeliveryAmountDrill, //已交付金额钻取
        },
        {
          path: '/warning',
          name: 'warning',
          component: EarlyWarningProject, //项目预警详情页面
        },
        {
          path: '/prodetails',
          name: 'prodetails',
          component: ProjectDetailDrill, //项目钻取页面
        },
        {
          path: '/openticket',
          name: 'openticket',
          component: OpenTicket, //开票详情页面
        },
        {
          path: '/openticketlist',
          name: 'openticketlist',
          component: OpenTicketList, //开票详情页面
        },
        {
          path: '/ticketapply',
          name: 'ticketapply',
          component: TicketApply, //开票申请页面
        },
        {
          path: '/ticketlist',
          name: 'ticketlist',
          component: TicketList, //开票列表页面
        },
        {
          path:'/allproject',
          name:'allproject',
          component:AllProject,//开票项目名称页面
        },
        {
          path: '/prolist',
          name: 'prolist',
          component: ProjectList, //开票详情页面
        },

        {
          path: '/irdrill',
          name: 'irdrill',
          component: InvoicedReturnDrill,//分析页面右侧按钮点击出现侧滑页面，筛选》时间》区域》确定，已开发票
        },
        {
          path: '/nirdrill',
          name: 'nirdrill',
          component: NoInvoicedReturnDrill,//未开发票钻取
        },
        {
          path: '/armrdrill',
          name: 'armrdrill',
          component: AreaReturnedMoneyRatioDrill,
        },
        {
          path: '/drmdrill',
          name: 'drmdrill',
          component:DeliveredReturnedMoneyDrill,
        },
        {
          path: '/mbmdrill',
          name: 'mbmdrill',
          component:MakeBackMoneyDrill,// 制作部项目回款金额占比钻取
        },
        {
          path: '/mddrill',
          name: 'mddrill',
          component:MakeDeliverDrill,//制作部交付总金额占比钻取
        },
        {
          path: '/mhirmdrill',
          name: 'mhirmdrill',
          component:MakeHasInvoiceReturnMoneyDrill, //制作部以开发票待回款钻取
        },
        {
          path: '/msdrill',
          name: 'msdrill',
          component:MakeSomeDrill,
        },
        {
          path: '/analyze',// // 分析=》业务 =》项目签约明细页面
          name: 'analyze',
          component: Analyze,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/analyzeclick',
          name: 'analyzeclick',
          component: AnalyzeClick,  // 项目签约明细列表中的单个详情
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/sales',
          name: 'sales',
          component: Sales,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/case',
          name: 'case',
          component: Case,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/my',
          name: 'my',
          component: My,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/news',
          name: 'news',
          component: News,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/mission',
          name: 'mission',
          component: Mission,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/salerank',
          name: 'backrank',
          component: BackRank,
          meta: {
            requireAuth: true,
          },
        },
        {
            path: '/performance',
            name: 'performance',
            component: Performance,
            meta: {
              requireAuth: true,
            },
          },
        {
            path: '/ranking',
            name: 'Ranking',
            component: Ranking,
            meta: {
              requireAuth: true,
            },
          },
        {
          path: '/saledetail',
          name: 'backdetail',
          component: BackDetail,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/caseapp/:id',
          name: 'caseapp',
          component: CaseApp,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/caseothers/:id',
          name: 'caseothers',
          component: CaseOthers,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/casesaas/:id',
          name: 'casesaas',
          component: CaseSaas,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/business',
          name: 'business',
          component: Business,
          children:[
            {
              path: '/business/mon',
              name: 'businessmon',
              component: BusinessMon,
              meta: {
                requireAuth: true,
              },
            },
            {
              path: '/business/year',
              name: 'businessyear',
              component: BusinessYear,
              meta: {
                requireAuth: true,
              },
            },
            {
              path: '/business/make',
              name: 'make',
              component: Make,
              meta: {
                requireAuth: true,
              },
            },
            {
              path: '/business/project',
              name: 'project',
              component: Project,
              meta: {
                requireAuth: true,
              },
            },
          ]
        },
        {
          path: '/projectclick',
          name: 'projectclick',
          component: ProjectClick,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/myproject',
          name: 'myproject',
          component: MyProject,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: '/knowledge',
          name: 'knowledge',
          component: Knowledge,
          meta: {
            requireAuth: true,
          },
        },
        {
            path: '/fusion',
            name: 'fusion',
            component: Fusion,
            meta: {
              requireAuth: true,
            },
          },
        {
          path: '/buglist',
          name: 'buglist',
          component: BugList,
          meta: {
            requireAuth: true,
          }
        },
        {
          path:'/examine',
          name:'examine',
          component:Examine,
          meta:{
            requireAuth:true
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      children:[

      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js